export default __webpack_public_path__ + "static/media/IconBookActive.75ce5ae1.svg";